/*
 * Shipping protection add-on for the cart drawer and cart page
 * (markup: snippets/shipping-protection.liquid).
 * - Ticking adds the protection variant (/cart/add.js), unticking removes it (/cart/change.js, quantity 0).
 * - Keeps the protection line at quantity 1, and removes it when it's the only thing in the cart.
 * - Re-renders the cart drawer and cart page sections after every change.
 */
(function () {
  if (customElements.get('shipping-protection')) return;

  var busy = false;

  function url(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function postJSON(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function getCart() {
    return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function protectionLines(cart, productId) {
    return cart.items.filter(function (item) {
      return String(item.product_id) === String(productId);
    });
  }

  // Set the protection quantity to `quantity` (0 or 1), collapsing any duplicate lines.
  function setProtection(variantId, productId, quantity) {
    return getCart().then(function (cart) {
      var lines = protectionLines(cart, productId);
      var chain = Promise.resolve();
      lines.forEach(function (line, index) {
        var target = index === 0 ? quantity : 0;
        if (line.quantity !== target) {
          chain = chain.then(function () {
            return postJSON('/cart/change.js', { id: line.key, quantity: target });
          });
        }
      });
      if (quantity > 0 && lines.length === 0) {
        chain = chain.then(function () {
          return postJSON('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
        });
      }
      return chain;
    });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // Same refresh the theme does after its own cart changes (see CartNotification / CartItems).
  function refreshCart() {
    return getCart().then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        if (el.classList.contains('cart-count-drawer')) {
          el.innerHTML = '(' + cart.item_count + ')';
        } else {
          el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
        }
      });
      var headerTotal = document.querySelector('header-total-price');
      if (headerTotal && headerTotal.updateTotal) headerTotal.updateTotal(cart);

      var drawer = document.getElementById('minicart-form');
      var page = document.getElementById('main-cart-items');
      var sections = [];
      if (drawer) sections.push('minicart-form');
      if (page && page.dataset.id) sections.push(page.dataset.id);
      if (!sections.length) return;

      return fetch(window.location.pathname + '?sections=' + sections.join(','))
        .then(function (res) {
          return res.json();
        })
        .then(function (html) {
          if (drawer && html['minicart-form']) {
            var newDrawer = parse(html['minicart-form']).querySelector('#minicart-form');
            if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
            var notification = document.querySelector('cart-notification');
            if (notification && notification.cartAction) notification.cartAction();
          }
          if (page && html[page.dataset.id]) {
            var newPage = parse(html[page.dataset.id]).querySelector('#main-cart-items');
            if (newPage) page.innerHTML = newPage.innerHTML;
          }
          var freeShip = document.querySelector('free-ship-progress-bar');
          if (freeShip && freeShip.init) freeShip.init(cart.items_subtotal_price);
        });
    });
  }

  // The cart page's own quantity updates re-render only the item list, not this block,
  // so watch the list and re-check the cart when it changes.
  var observed = new WeakSet();
  var syncTimer;
  function watchCartPage(box) {
    var list = document.querySelector('#main-cart-items cart-items');
    if (!list || observed.has(list)) return;
    observed.add(list);
    new MutationObserver(function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        if (busy || !box.isConnected) return;
        getCart().then(function (cart) {
          var lines = protectionLines(cart, box.dataset.productId);
          var qty = lines.reduce(function (sum, line) {
            return sum + line.quantity;
          }, 0);
          if (qty > 0 && qty === cart.item_count) box.run(0);
          else if (qty > 1 || lines.length > 1) box.run(1);
          else
            document.querySelectorAll('.shipping-protection__checkbox').forEach(function (input) {
              input.checked = qty > 0;
            });
        });
      }, 400);
    }).observe(list, { childList: true });
  }

  class ShippingProtection extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.shipping-protection__checkbox');
      if (!this.input) return;
      this.input.addEventListener('change', this.onChange.bind(this));
      if (this.closest('#main-cart-items')) watchCartPage(this);

      // Housekeeping: drop protection when it's the only item, and keep it at quantity 1.
      var qty = Number(this.dataset.qty || 0);
      if (this.dataset.only === 'true') this.run(0);
      else if (qty > 1) this.run(1);
    }

    onChange() {
      if (busy) {
        this.input.checked = !this.input.checked;
        return;
      }
      this.run(this.input.checked ? 1 : 0);
    }

    run(quantity) {
      if (busy) return;
      busy = true;
      var boxes = document.querySelectorAll('shipping-protection');
      boxes.forEach(function (box) {
        box.classList.add('loading');
        var input = box.querySelector('.shipping-protection__checkbox');
        if (input) input.disabled = true;
      });

      var self = this;
      setProtection(this.dataset.variantId, this.dataset.productId, quantity)
        .catch(function (error) {
          console.error('Shipping protection update failed', error);
        })
        .then(refreshCart)
        .catch(function (error) {
          console.error('Cart refresh failed', error);
        })
        .finally(function () {
          busy = false;
          document.querySelectorAll('shipping-protection').forEach(function (box) {
            box.classList.remove('loading');
            var input = box.querySelector('.shipping-protection__checkbox');
            if (input) input.disabled = false;
          });
          // Keep any box that wasn't re-rendered in sync with the cart.
          getCart().then(function (cart) {
            var inCart = protectionLines(cart, self.dataset.productId).length > 0;
            document.querySelectorAll('.shipping-protection__checkbox').forEach(function (input) {
              input.checked = inCart;
            });
          });
        });
    }
  }

  customElements.define('shipping-protection', ShippingProtection);
})();
